module.exports = __webpack_public_path__ + "img/34.f6027c4e.png";